export const DsfPolicyComFooter = dsf.defineAsyncComponent("DsfPolicyComFooter", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./ComFooter.vue")
);
export const DsfPolicyComHeader = dsf.defineAsyncComponent("DsfPolicyComHeader", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./ComHeader.vue")
);
export const DsfPolicyHomeMain = dsf.defineAsyncComponent("DsfPolicyHomeMain", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./HomeMain.vue")
);
export const DsfPolicyHomeMainCopy = dsf.defineAsyncComponent("DsfPolicyHomeMainCopy", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./HomeMainCopy.vue")
);
export const DsfPolicyList = dsf.defineAsyncComponent("DsfPolicyList", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyList.vue")
);
export const DsfPolicyNewsDetail = dsf.defineAsyncComponent("DsfPolicyNewsDetail", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyNewsDetail.vue")
);
export const DsfPolicyDetail = dsf.defineAsyncComponent("DsfPolicyDetail", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyDetail.vue")
);
export const DsfPolicyRecommendList = dsf.defineAsyncComponent("DsfPolicyRecommendList", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyRecommendList.vue")
);
export const DsfAppealArea = dsf.defineAsyncComponent("DsfAppealArea", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./AppealArea.vue")
);
export const DsfAppealDetail = dsf.defineAsyncComponent("DsfAppealDetail", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./AppealDetail.vue")
);
export const DsfPolicyRecommendListAll = dsf.defineAsyncComponent("DsfPolicyRecommendListAll", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyRecommendListAll.vue")
);
export const DsfPolicyRecommendListOfficer = dsf.defineAsyncComponent("DsfPolicyRecommendListOfficer", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyRecommendListOfficer.vue")
);
export const DsfAppealSearch = dsf.defineAsyncComponent("DsfAppealSearch", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./AppealSearch.vue")
);
export const DsfAppealHanddle = dsf.defineAsyncComponent("DsfAppealHanddle", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./AppealHanddle.vue")
);
export const DsfWisecoreLogo = dsf.defineAsyncComponent("DsfWisecoreLogo", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./logo.vue")
);
export const DsfPolicyPannel = dsf.defineAsyncComponent("DsfPolicyPannel", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyPannel.vue")
);
export const DsfPolicyPannelItem = dsf.defineAsyncComponent("DsfPolicyPannelItem", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyPannelItem.vue")
);
export const DsfPolicyBreakdown = dsf.defineAsyncComponent("DsfPolicyBreakdown", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyBreakdown.vue")
);
export const DsfSupportStandard = dsf.defineAsyncComponent("DsfSupportStandard", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./SupportStandard.vue")
);
export const DsfPolicyCompanyList = dsf.defineAsyncComponent("DsfPolicyCompanyList", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./CompanyList.vue")
);
export const DsfPolicyDemandHome = dsf.defineAsyncComponent("DsfPolicyDemandHome", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./DemandHome.vue")
);
export const DsfPolicyDemandHomeHeader = dsf.defineAsyncComponent("DsfPolicyDemandHomeHeader", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./DemandHomeHeader.vue")
);
export const DsfPolicyDemandHomeMain = dsf.defineAsyncComponent("DsfPolicyDemandHomeMain", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./DemandHomeMain.vue")
);
export const DsfPolicyMetadataExtraction = dsf.defineAsyncComponent("DsfPolicyMetadataExtraction", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./MetadataExtraction.vue")
);
export const DsfPolicyKnowledgeSearch = dsf.defineAsyncComponent("DsfPolicyKnowledgeSearch", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyKnowledgeSearch.vue")
);
export const DsfPolicyKnowledgeDetail = dsf.defineAsyncComponent("DsfPolicyKnowledgeDetail", () =>
  import(/* webpackChunkName: "pc_policy_module" */ "./PolicyKnowledgeDetail.vue")
);
